<script lang="ts" setup>
import InputText, { type InputTextEmits, type InputTextProps } from 'primevue/inputtext'

interface Props extends /* @vue-ignore */ Omit<InputTextProps, 'size' | 'fluid'> {
  error?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ InputTextEmits {}
defineProps<Props>()
defineEmits<Emits>()

const [model, modifiers] = defineModel<Props['modelValue'] | null>({
  set(v) {
    if (modifiers.nocase) return v
    else if (modifiers.lowercase) return v?.toLowerCase()

    return v?.toUpperCase()
  },
})

const errorInjected = inject<Ref<boolean>>('error', ref(false))
</script>

<template>
  <InputText
    v-bind="$props"
    v-model="model"
    fluid
    :size="$viewport.isLessThan('md') ? 'small' : undefined"
    :invalid="errorInjected || error"
  />
</template>
